export default {
	props: {
		value: {
			type: Object,
			required: true
		}
	},
	functional: true,
	render(createElement, { props, listeners, children }) {
		const links = children.map(child => {
			const field = child.data.attrs.field;
			const ascending = Object.prototype.hasOwnProperty.call(
				child.data.attrs,
				'ascending'
			);
			if (field === props.value.field) {
				return createElement(
					'a',
					{
						class: 'text-no-wrap font-weight-bold',
						on: {
							click: () => {
								listeners.input({
									ascending: !props.value.ascending,
									field: props.value.field
								});
							}
						}
					},
					[
						child.children,
						createElement('v-icon', { props: { color: 'primary' } }, [
							props.value.ascending ? 'arrow_drop_up' : 'arrow_drop_down'
						])
					]
				);
			} else {
				return createElement(
					'a',
					{
						class: 'text-no-wrap',
						on: {
							click: () => {
								listeners.input({
									ascending,
									field
								});
							}
						}
					},
					child.children
				);
			}
		});

		return createElement('v-col', { class: 'shrink grey--text text-no-wrap' }, [
			links
				.slice(1)
				.reduce((carry, link) => carry.concat(' · ', link), [links[0]])
		]);
	}
};
